import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";

import Breadcrumbs from "../../Components/Common/Breadcrumb";
import "./checkout.css";
import PaymentForm from "./PaymentForm";
import ConfirmationDetails from "./ConfirmationDetails";
import CartItems from "./CartItems";

const POSCheckout = () => {
  document.title = "Checkout | Papermap";

  const [activeTab, setActiveTab] = useState<string>("1");

  return (
    <>
      <div className="page-content">
        <Container>
          <Breadcrumbs title="Ecommerce" breadcrumbItem="Checkout" />

          <div className="checkout-tabs">
            <Row>
              <Col xl={2} sm={3}>
                <Nav className="flex-column" pills>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" })}
                      onClick={() => setActiveTab("1")}
                    >
                      <i className="bx bx-cart d-block check-nav-icon mt-4 mb-2" />
                      <p className="fw-bold mb-4">Cart Items</p>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => setActiveTab("2")}
                    >
                      <i className="bx bx-money d-block check-nav-icon mt-4 mb-2" />
                      <p className="fw-bold mb-4">Payment Info</p>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "3" })}
                    >
                      <i className="bx bx-check-circle d-block check-nav-icon mt-4 mb-2" />
                      <p className="fw-bold mb-4">Confirmation</p>
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>

              <Col xl={10} sm={9}>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <CartItems cart={[]} setActiveTab={setActiveTab} />
                  </TabPane>
                  {/* Payment Info */}
                  <TabPane tabId="2">
                    <PaymentForm setActiveTab={setActiveTab} />
                  </TabPane>

                  {/* Confirmation Details */}
                  <TabPane tabId="3">
                    <ConfirmationDetails setActiveTab={setActiveTab} />
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default POSCheckout;
